module.exports = __webpack_public_path__ + "bae418b6b082fb09d6a33108dca7146d.png";